// api/pullLogs/pullLog.js
import Resource from '../resource'
import request from '../../utils/request';

class pullLog extends Resource {
    constructor() {
        super('pullLogs');
    }

    // Updated pullData to trigger async queue
    pullData(payload) {
        return request({
            url: `/pullLogs/pull/${payload.id}`,
            method: 'post',
            data: { date: payload.date },
        });
    }

    // Get pull status for a specific connection
    getPullStatus(connection_name) {
        return request({
            url: `/pullLogs/status/${connection_name}`,
            method: 'get',
        });
    }

    // Get full log details for a specific pull job
    getPullLogDetails(pull_id) {
        return request({
            url: `/pullLogs/details/${pull_id}`,
            method: 'get',
        });
    }
}

export { pullLog as default };